// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.puzzle-table-container {
  width: 100%; /* or a specific width like 500px */
  max-width: 100%;
  overflow: auto; /* Adds a horizontal scrollbar if the content is too wide */
  box-sizing: border-box;
  display: flex;
  max-height: 70vh;
}


@media (max-height: 900px) {
  .puzzle-table-container {
      max-height: 670px;
  }
}


@media (max-height: 667px) {
  .puzzle-table-container {
      max-height: 460px;
  }
}

@media (max-height: 400px) {
  .puzzle-table-container {
      max-height: 100px;
  }
}


.puzzle-table-container table {
  margin:auto;
  table-layout: auto;
}

.puzzle-table-container tbody tr {
  background-color: rgba(180, 180, 180, 0.096);
  height: 50px;
}

.puzzle-table-container tbody td .actions-cell {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: rgb(247, 206, 199);
}

.puzzle-table-container tbody td {
  pointer-events: all;
  -webkit-user-select: text;
          user-select: text;
}

.actions-cell-action-button {
  font-size: x-small;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(250, 215, 215);
  border-radius: 5px;
  min-width: 40px;
  padding: 5px;
  margin: 5px;
}

.actions-buttons-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 5px;
}

.actions-cell-action-button:hover {
  background-color: rgba(0, 140, 255, 0.562);
  cursor:pointer
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/Dashboard/PuzzleTable/PuzzleTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW,EAAE,mCAAmC;EAChD,eAAe;EACf,cAAc,EAAE,2DAA2D;EAC3E,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;;AAGA;EACE;MACI,iBAAiB;EACrB;AACF;;;AAGA;EACE;MACI,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,iBAAiB;EACrB;AACF;;;AAGA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C;AACF","sourcesContent":[".puzzle-table-container {\n  width: 100%; /* or a specific width like 500px */\n  max-width: 100%;\n  overflow: auto; /* Adds a horizontal scrollbar if the content is too wide */\n  box-sizing: border-box;\n  display: flex;\n  max-height: 70vh;\n}\n\n\n@media (max-height: 900px) {\n  .puzzle-table-container {\n      max-height: 670px;\n  }\n}\n\n\n@media (max-height: 667px) {\n  .puzzle-table-container {\n      max-height: 460px;\n  }\n}\n\n@media (max-height: 400px) {\n  .puzzle-table-container {\n      max-height: 100px;\n  }\n}\n\n\n.puzzle-table-container table {\n  margin:auto;\n  table-layout: auto;\n}\n\n.puzzle-table-container tbody tr {\n  background-color: rgba(180, 180, 180, 0.096);\n  height: 50px;\n}\n\n.puzzle-table-container tbody td .actions-cell {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(247, 206, 199);\n}\n\n.puzzle-table-container tbody td {\n  pointer-events: all;\n  user-select: text;\n}\n\n.actions-cell-action-button {\n  font-size: x-small;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(250, 215, 215);\n  border-radius: 5px;\n  min-width: 40px;\n  padding: 5px;\n  margin: 5px;\n}\n\n.actions-buttons-container {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  gap: 5px;\n}\n\n.actions-cell-action-button:hover {\n  background-color: rgba(0, 140, 255, 0.562);\n  cursor:pointer\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
